//scroll variable to track window's scroll
var lastScrollTop = 0;

// Func = limiting Scope for this file
(function () {
	window.onload = function () {
		scrollW()
	}

	window.addEventListener('scroll', function () {
		scrollW()
	})

	// Burger Menu open
	document.querySelector(".js-burger-menu").addEventListener('click',(e)=>{
		e.preventDefault();
		document.querySelector(".burger-menu").classList.add("open")
	})
	
	// Burger Menu close
	document.querySelector("#burger-close").addEventListener('click',(e)=>{
		e.preventDefault();
		document.querySelector(".burger-menu").classList.remove("open")
	})


	//Mobile funcionality  
	document.querySelectorAll(".navigation li a").forEach(item =>{ 
		item.addEventListener('click',()=>{
			document.querySelector(".burger-menu").classList.remove("open")
		})
	})

	// Add span for btn
	document.querySelectorAll(".btn , .signup-btn").forEach(function (item, i) {
		let lineText = item.textContent;
		let html = `
			<span class="line"></span>
				${lineText}
			<span class="line"></span>
		`;
		item.innerHTML = html;
	});

	// Add smooth scrolling to all links
	$(".privary-navigation a").on('click', function (event) {

		var thisHref = $(this).attr('href');
		var thisHash = thisHref.split('#');
		var thisId = '#' + thisHash[1];
		var thisTop = $(thisId).offset().top;
		var thisItem = $(this);
		$('html,body').animate({
			scrollTop: thisTop - 100
		}, 1200, function () {
			$('.privary-navigation a').removeClass('active');
			thisItem.addClass('active');
		});
		event.preventDefault();
	});

	//input date mobile
	let inputs = document.querySelectorAll('input[type=date]');
	for (let i = 0; i < inputs.length; i++) {
		inputs[i].addEventListener('input', function () {
			if (this.value.length > 0) {
				this.classList.add('full');
			} else {
				this.classList.remove('full');
			}
		});

	}
	//header logo
	document.querySelector(".header-logo").parentElement.classList.add('logo-parent');
	document.querySelector(".header-logo").href = "/";

	let menubutton = document.querySelectorAll('.accordion-menu__item .accordion-menu__back .btn')
	menubutton.forEach(botton => {
		botton.addEventListener('click', selectbutton);
	})


	function selectbutton() {

		let ubicacion = this.parentNode.nextElementSibling;
		ubicacion.querySelectorAll('.menu-tabs-js li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				ubicacion.querySelectorAll('.menu-tabs-js li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				ubicacion.querySelectorAll('.menu-tab-js').forEach(menu => {
					menu.classList.remove('active');
					if (btn.dataset.tag === 'all' || btn.dataset.tag === menu.dataset.tag) {
						menu.classList.add('active');
					}
				});

			});
		})

	}



})()


function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;

	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');

		}

	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


//animation of scroll vanilla JS
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 100
	var from = window.pageYOffset
	var to = gotoTarget
	var duration = 1300
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start

		if (from <= to) {
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)
	}, 1000 / 60)

	window.scrollTo(0, from)
}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b
}

//window offset
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop
	return {
		top: rect.top + scrollTop,
		left: rect.left + scrollLeft
	}
}

// Change position submit button
let submitBtn = document.querySelector(".signup-btn");
let fieldsWrap = document.querySelector(".fields-wrap");
if( fieldsWrap ){
	let gpdrWrap = fieldsWrap.getElementsByTagName('div');
	fieldsWrap.insertBefore(submitBtn, gpdrWrap[2]);
}